<button
  type="button"
  (click)="onRedeem()"
  [title]="coupon().OfferOnCard"
  class="tw-group tw-relative tw-flex tw-flex-col tw-items-start tw-w-full tw-min-w-[124px] tw-h-[125px] tw-gap-1.5 tw-text-left tw-rounded-2xl tw-bg-color-surface-card tw-p-2 tw-shadow-list tw-overflow-hidden tw-transition-all active:tw-scale-[0.98]"
>
  <div
    class="tw-flex tw-items-center tw-justify-center tw-w-full tw-h-9 tw-bg-white tw-rounded-lg tw-p-1 tw-flex-shrink-0"
  >
    <svg class="tw-w-full tw-h-full">
      <use [attr.xlink:href]="'images/sprite.svg#' + coupon().logoSvg"></use>
    </svg>
  </div>

  <span
    class="tw-w-full tw-text-[13px] tw-font-semibold tw-leading-[1.25] tw-text-color-text-default tw-truncate"
  >
    {{ coupon().attribute }}
  </span>

  <span
    class="tw-w-full tw-text-[11px] tw-font-medium tw-leading-[1.3] tw-text-color-text-tertiary tw-line-clamp-3"
  >
    {{ coupon().OfferOnCard }}
  </span>
</button>
